<template>
  <nav class="top-bar">
    <h3 class="top-bar__title hide-desktop hide-tablet">Кабинет брокера</h3>
    <div class="top-bar__left top-bar__item">
      <router-link to="/finance"
        ><img
          src="@/assets/images/logo_white.svg"
          alt="FHS logo"
          class="top-bar__logo hide-mobile"
      /></router-link>
      <div v-if="systemStatus === 40 && isLoggedIn">
        <currency-rate class="top-bar__currency-rate hide-mobile" />
      </div>
    </div>
    <div class="top-bar__right top-bar__item">
      <!--        v-if="isUserVIP"-->
      <!--      <broker-select-->
      <!--        v-if="isLoggedIn"-->
      <!--        class="top-bar__select hide-tablet hide-mobile"-->
      <!--      ></broker-select>-->
      <!--      <div class="broker-select">-->
      <!--        <p class="broker-select__title">{{ $t("select portfolio") }}</p>-->
      <!--        <fhs-select :options="[1, 2, 3, 4]" class="broker-select__select" />-->
      <!--        &lt;!&ndash;          @handleSelect="changeSelectedPortfolio"&ndash;&gt;-->
      <!--      </div>-->
      <!--      <portfolio-select-->
      <!--        v-if="isLoggedIn"-->
      <!--        :options="portfoliosListOptions"-->
      <!--        class="top-bar__select hide-tablet hide-mobile"-->
      <!--      />-->
      <!--      <div class="lang-select top-bar__select hide-tablet hide-mobile">-->
      <!--        <p class="lang-select__title">{{ $t("lang") }}</p>-->
      <!--        <fhs-select-->
      <!--          :options="[-->
      <!--            {-->
      <!--              value: 'ru',-->
      <!--              text: 'Рус',-->
      <!--              selected: true-->
      <!--            },-->
      <!--            {-->
      <!--              value: 'kz',-->
      <!--              text: 'Қаз'-->
      <!--            },-->
      <!--            {-->
      <!--              value: 'en',-->
      <!--              text: 'Eng'-->
      <!--            }-->
      <!--          ]"-->
      <!--          style="margin-top: 0px;"-->
      <!--          @handleSelect="changeLang"-->
      <!--          class="lang-select__select hide-tablet hide-mobile"-->
      <!--        />-->
      <!--      </div>-->
      <a
        v-if="isLoggedIn"
        @click="toggleUserDropdown"
        class="top-bar__user hide-mobile"
      >
        <div class="top-bar__user-avatar"></div>
        <span class="top-bar__user-name" style="font-size: 16px;">
          {{ fullName || "Загрузка..." }} <br />
          <span
            style="color: #767d8a !important; font-size: 12px !important;"
            v-if="portfoliosList.length > 2"
          >
            Порфель:
            {{ this.portfoliosList.filter(item => item.selected)[0].text }}
          </span>
        </span>
        <span style="color: white"
          ><icon-fa
            :icon="!isUserDropdownVisible ? 'angle-down' : 'angle-up'"
          ></icon-fa
        ></span>
      </a>
    </div>
    <user-menu :close="!isUserDropdownVisible"></user-menu>
    <!--    <user-dropdown :isVisible="isUserDropdownVisible" class="user-dropdown" />-->
  </nav>
</template>

<script>
import SelectPrimary from "@/components/ui-kit/SelectPrimary";
import BrokerSelect from "@/components/common/BrokerSelect";
import PortfolioSelect from "@/components/common/PortfolioSelect";
import CurrencyRate from "@/components/common/CurrencyRate";
import UserMenu from "./UserMenu";
import UserDropdown from "@/components/common/UserDropdown";
import i18n from "@/lib/vue-i18n/index";
import { mapGetters } from "vuex";

export default {
  components: {
    "fhs-select": SelectPrimary,
    "broker-select": BrokerSelect,
    "portfolio-select": PortfolioSelect,
    "currency-rate": CurrencyRate,
    "user-dropdown": UserDropdown,
    UserMenu
  },
  data() {
    return {
      isUserDropdownVisible: false
    };
  },
  computed: {
    fullName() {
      if (this.$store.getters.systemStatus === 40) {
        return this.aisUserName;
      } else {
        if (this.getUserProfile && this.getUserProfile.user) {
          let fname = this.getUserProfile.user.firstname || "";
          let lname = this.getUserProfile.user.lastname || "";
          let mname = this.getUserProfile.user.middlename || "";
          return `${lname} ${fname.substr(0, 1)} ${mname.substr(0, 1)} `;
        }
        return "Загрузка...";
      }
    },
    brokersListOptions() {
      return this.$store.getters.brokersList;
    },
    portfoliosListOptions() {
      return this.$store.getters.portfoliosList;
    },
    languageList() {
      return [
        {
          value: "ru",
          text: "Рус",
          selected: i18n.locale == "ru" ? true : false
        },
        {
          value: "kz",
          text: "Қаз",
          selected: i18n.locale == "kz" ? true : false
        },
        {
          value: "en",
          text: "Eng",
          selected: i18n.locale == "en" ? true : false
        }
      ];
    },
    userName() {
      return this.$store.getters.userName;
    },
    ...mapGetters([
      "getUserProfile",
      "isLoggedIn",
      "isUserVIP",
      "companyName",
      "aisUserName",
      "systemStatus",
      "selectedPortfolio",
      "portfoliosList"
    ])
  },
  methods: {
    getFio(aisUserName) {
      if (aisUserName != undefined) {
        var t = aisUserName.split(" ");
        if (t.length == 3) {
          var shortFIO =
            t[0] + " " + t[1].charAt(0) + ". " + t[2].charAt(0) + ".";
        } else {
          shortFIO = aisUserName;
        }
        return shortFIO;
      }
    },
    changeLang(selectedLang) {
      i18n.locale = selectedLang;
      // this.$store.dispatch("fetchAccountData");
    },
    toggleUserDropdown() {
      this.isUserDropdownVisible = !this.isUserDropdownVisible;
    }
  },
  mounted() {
    window.addEventListener("click", e => {
      // Если нажание было по кнопке активации, то прерываем функцию
      // console.log(e);
      const { path } = e;
      const result = path.filter(el => el.className === "lk-menu").length > 0;
      if (result) {
        return;
      } else {
        // let drop_down = path.filter(el => {
        //   console.log(el.className);
        // });s
        // console.log(drop_down);
        let click =
          path.filter(
            el => el.className && el.className.includes("top-bar__user")
          ).length > 0;
        console.log(click);
        if (click) {
          this.isUserDropdownVisible = true;
          return;
        }
        this.isUserDropdownVisible = false;
      }
      // console.log(result.length > 0);
      // this.isUserDropdownVisible = !(result.length > 0);
      // if (
      //   e.target.parentNode.classList.contains("top-bar__user") ||
      //   e.target.parentNode.classList.contains("lk-menu")
      // ) {
      //   return;
      // }
      // Иначе закрываем dropdown
    });
  }
};
</script>

<style scoped>
.top-bar {
  height: 100px;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  background-color: #2f3a57;
}

.top-bar__registration-steps {
  align-self: center;
}

.user-dropdown {
  position: absolute;
  top: 10vh;
  right: 10px;
  z-index: 5;
}

.top-bar__title {
  font-size: 15px;
  font-weight: normal;
}

.top-bar__item {
  display: flex;
  align-items: center;
}

.top-bar__currency-rate {
  margin-left: 50px;
}

.top-bar__user {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.top-bar__user-avatar {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #222c44;
}

.top-bar__user-name {
  width: 250px;
  word-break: break-word;
  margin-left: 9px;
  font-size: 12px;
  cursor: pointer;
}

.top-bar__select {
  margin-right: 40px;
  font-size: 12px;
  color: #ffffff;
  background-color: transparent;
  border: none;
}

.lang-select {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.lang-select__title {
  margin: 0 0 5px 4px;
  font-size: 13px;
  color: #acb5c5;
}

.lang-select__select {
  padding: 0;
  font-size: 12px;
  color: #ffffff;
  background-color: #384770;
  border: none;
  padding: 4px;
}

option {
  color: #000000 !important;
}

@media (max-width: 600px) {
  .top-bar {
    justify-content: center;
  }
}
</style>
